import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './main/App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {RootErrorBoundary} from "./services/ErrorBoundary";
import {installerCapteursGlobaux} from "./services/signalerErreur";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {installerLeSuiviDesMisesAJour} from "./services/miseAJour";

// La constante vit desormais dans son propre module. On la re-exporte : trois
// composants l'importent d'ici, et un point d'entree n'a pas a devenir un
// module de constantes pour autant.
export {version_timed} from "./version";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      {/* Le dernier filet, a l'interieur du routeur : l'ecran d'erreur propose
          une sortie, donc il a besoin de la navigation. Les 82 frontieres de
          l'application sont posees dans les routes, donc sous le layout — un
          plantage du layout lui-meme n'etait attrape par personne et donnait
          une page blanche muette, sans meme le bouton dont on discutait. */}
      <BrowserRouter>
        <RootErrorBoundary>
          <App />
        </RootErrorBoundary>
      </BrowserRouter>
  </React.StrictMode>
);

// Ce que les frontieres ne verront jamais : les gestionnaires d'evenement et
// les promesses rejetees. Elles ne peuvent rien afficher, seulement raconter.
installerCapteursGlobaux();

serviceWorkerRegistration.register();

// Le worker installe attend desormais son tour au lieu de saisir la page.
// C'est ce suivi qui repere son arrivee, le propose, et recharge une fois la
// bascule faite. Voir le ticket 018, etage 2.
installerLeSuiviDesMisesAJour();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(consolex.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
